import React from 'react';

import './index.less';

import { ToolsetModel, ToolsetSettingsType, ToolsetState } from '../../../../../../gamma-api';

import ELMA365ToolkitToolset from './ELMA365ToolkitToolset';
import AgentToolset from './AgentToolset';
import SmartSearchToolset from './SmartSearchToolset';
import MCPServerToolset from './MCPServerToolset';
import BaseToolsetListItem from './BaseToolsetListItem';
import ELMA365GeneralToolset from './ELMA365GeneralToolset';
import FileToolset from './FileToolset';
import { DATE_TIME_TOOLSET_TOOL_COUNT, WEB_TOOLSET_TOOL_COUNT } from './const';

export interface IToolsetListItemProps {
  toolset: ToolsetModel;
  onSetup?: (toolset: ToolsetModel) => void;
  onDelete?: (toolset: ToolsetModel) => void;
  onToolsetStateChange?: (toolset: ToolsetModel, state: ToolsetState) => void;
}

const ToolsetListItem: React.FC<IToolsetListItemProps> = ({ toolset, onSetup, onDelete, onToolsetStateChange }) => {
  if (toolset.type === ToolsetSettingsType.McpServer) {
    // TODO: Получать количество инструментов MCP
    return (
      <MCPServerToolset
        toolset={toolset}
        onDelete={onDelete}
        onSetup={onSetup}
        onToolsetStateChange={onToolsetStateChange}
      />
    );
  }

  if (toolset.type === ToolsetSettingsType.DateTime) {
    return (
      <BaseToolsetListItem
        toolCount={DATE_TIME_TOOLSET_TOOL_COUNT}
        toolset={toolset}
        onDelete={onDelete}
        onToolsetStateChange={onToolsetStateChange}
      />
    );
  }

  if (toolset.type === ToolsetSettingsType.SmartSearch) {
    return (
      <SmartSearchToolset
        toolset={toolset}
        onDelete={onDelete}
        onSetup={onSetup}
        onToolsetStateChange={onToolsetStateChange}
      />
    );
  }

  if (toolset.type === ToolsetSettingsType.Web) {
    return (
      <BaseToolsetListItem
        toolCount={WEB_TOOLSET_TOOL_COUNT}
        toolset={toolset}
        onDelete={onDelete}
        onSetup={onSetup}
        onToolsetStateChange={onToolsetStateChange}
      />
    );
  }

  if (toolset.type === ToolsetSettingsType.Elma365General) {
    return (
      <ELMA365GeneralToolset
        toolset={toolset}
        onDelete={onDelete}
        onSetup={onSetup}
        onToolsetStateChange={onToolsetStateChange}
      />
    );
  }

  if (toolset.type === ToolsetSettingsType.Elma365Toolkit) {
    return (
      <ELMA365ToolkitToolset
        toolset={toolset}
        onDelete={onDelete}
        onSetup={onSetup}
        onToolsetStateChange={onToolsetStateChange}
      />
    );
  }

  if (toolset.type === ToolsetSettingsType.File) {
    return (
      <FileToolset
        toolset={toolset}
        onDelete={onDelete}
        onSetup={onSetup}
        onToolsetStateChange={onToolsetStateChange}
      />
    );
  }

  if (toolset.type === ToolsetSettingsType.Agent) {
    return (
      <AgentToolset
        toolset={toolset}
        onDelete={onDelete}
        onSetup={onSetup}
        onToolsetStateChange={onToolsetStateChange}
      />
    );
  }

  throw new Error(`Toolset type '${toolset.type}' is not supported`);
};

export default ToolsetListItem;
